import React, {useState,useEffect,useRef} from "react";
import { Chart } from "primereact/chart";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

export const AccWiseTargetChart = (props) =>{

    const [dataLabels, setDataLabels] = useState(null)
    const [dataValues, setDataValues] = useState(null)
    const [chartData,setChartData] = useState(null)
    
    const dt = useRef(null);

    useEffect(() => {
        console.log(props.accWiseTargetData)
        getData(props.accWiseTargetData)
        setChartData(props.accWiseTargetData)
    },[props.accWiseTargetData])

    const getData = (data) =>{
        if(data){
            console.log(data);
            const values = data.map(x => x.ratio)
            setDataValues(values)
            const labels = data.map(x => x.siteName)
            setDataLabels(labels)
        }
    }

    

    const fieldTemplate = (rowData, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {rowData[props.field]}
            </>
        );
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    }


    const barData = {
        labels: dataLabels,
        datasets: [
            {
                label: 'Accounts',
                backgroundColor: '#00544d',
                borderColor: 'rgb(255, 99, 132)',
                data: dataValues,
                borderRadius: 5
            }
        ]
    };

    const barOptions = {
        plugins: {
            legend: {
                // labels: {
                //     color: '#A0A7B5'
                // }
                display:false
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color:  'rgba(160, 167, 181, .3)',
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color:  'rgba(160, 167, 181, .3)',
                }
            }
        }
    };

    
    return(

        <div className="card">

            <div className="card-header">
                <span>Flavorwise Cup Consumption</span>
                <div className='p-col-sm-4'>
                    <Button icon="pi pi-download" title='Download Report' className="p-button-rounded p-button-primary p-mr-2 p-mb-2" onClick={exportCSV} />
                </div>
            </div>
            {/* <h6 className="centerText"></h6> */}
            <Chart type="bar" data={barData} options={barOptions} />

            <DataTable style={{ display: 'none' }} ref={dt} value={chartData} dataKey="id" exportFilename="Accountwise Target Consumption" className="datatable-responsive" emptyMessage="No data found.">
                <Column field="siteName" header="Company Name" body={fieldTemplate}></Column>
                <Column field="target_cups" header="Total Cups" body={fieldTemplate}></Column>
            </DataTable>
        </div>

    )
}